import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/data";

export default function FaqSection() {
  return (
    <section id="faq" className="bg-[#070b12] text-[#f0f4f8] py-24 md:py-32 border-b border-[#1e9bff]/15" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-xs font-mono-lbl uppercase tracking-[0.2em] text-[#1e9bff] block mb-2">Common Questions</span>
          <h2 className="font-display uppercase text-white text-[clamp(32px,4vw,52px)] leading-none">
            Frequently Asked Questions
          </h2>
        </div>
        <Accordion type="single" collapsible className="space-y-4">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="p-6 rounded-xl bg-[#0b1322] border border-white/10 hover:border-[#1e9bff]/40 transition-colors"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-display uppercase text-lg text-white hover:no-underline py-0 [&>svg]:text-[#1e9bff]" data-testid={`faq-trigger-${i}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-[#93b4d4] pt-4">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
